import { Order } from '@components/account/types'
import { formatDate } from '@helpers/utils'
import Link from '@components/ui/Link'
import { CustomOrder } from '../../helpers/transformOrder'
import { ReactComponent as NewWindowIcon } from '@svgs/keyline/new-window.svg'
import styles from './styles.module.scss'
import { getReturnLink, canArrangeReturn } from '../../helpers/getReturnLink'

function getTrackingInformation(
  fulfillments: Partial<CustomOrder>['fulfillments']
) {
  const trackingMap = new Map<
    string,
    { number: string; url: string; company: string }
  >()

  fulfillments?.forEach(fulfillment => {
    if (fulfillment?.trackingInformation) {
      fulfillment.trackingInformation.forEach(({ number, url, company }) => {
        if (number && url && company) {
          trackingMap.set(number, { number, url, company })
        }
      })
    }
  })
  return Array.from(trackingMap.values())
}

export default function OrderPageContentHeaderInfo({
  order,
  orderSummary,
  status
}: {
  order: Order
  orderSummary: string
  status: string
}) {
  const { fulfillments, createdAt, updatedAt, shippingAddress, name } = order
  const trackingInformationList = getTrackingInformation(fulfillments)
  return (
    <div className={styles.OrderPageContent__header}>
      <div className={styles.OrderPageContent__headerDetails}>
        <p className={styles.orderSummary}>{orderSummary}</p>
        <span>
          <p>
            <strong>Order Placed</strong>
          </p>
          <p>{formatDate(createdAt)}</p>
        </span>
        {status === 'Delivered' && (
          <span>
            <p>
              <strong>Order Delivered</strong>
            </p>
            <p>{formatDate(updatedAt)}</p>
          </span>
        )}
      </div>
      {trackingInformationList && (
        <div className={styles.OrderPageContent__headerTrackingInfo}>
          {trackingInformationList.map(item => (
            <span key={`${item.company}-${item.number}`}>
              <p>
                <strong>Tracking Details</strong>
              </p>
              {item.url && (
                <Link
                  href={item.url}
                  target="_blank"
                  className={styles.OrderPageContent__headerTrackingLink}
                >
                  {item.company} <NewWindowIcon width="13" height="13" />
                </Link>
              )}
            </span>
          ))}

          {canArrangeReturn(status) && (
            <Link
              href={getReturnLink(name, shippingAddress?.zip || '')}
              target="_blank"
              classes={styles.OrderPageContent__arrangeReturnButton}
            >
              Arrange a return
            </Link>
          )}
        </div>
      )}
    </div>
  )
}
